import { render, staticRenderFns } from "./CapturaDocumentosFotoVerso.vue?vue&type=template&id=3fb609da&scoped=true&"
import script from "./CapturaDocumentosFotoVerso.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosFotoVerso.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosFotoVerso.vue?vue&type=style&index=0&id=3fb609da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb609da",
  null
  
)

export default component.exports